<app-modal title="VEHICLES.NEW_VEHICLE"
          [loading]="loading"
          (submitClicked)="submit()"
          [closeText]="'CANCEL'"
          [submitText]="'SAVE'"
          >
  <app-vehicle-form (formGroupOutput)="formGroup = $event"/>
</app-modal>
